import React from "react";
import { Flex, Box } from "grid-styled";
import JobActivities from "./JobActivities";
import { H2 } from "./Heading";
import { P } from "./Text";
import Modal from "./Modal";
import Button, { LinkButton } from "./Button";
import ServicesSidebar from "./ServicesSidebar";
import joinPath from "../utils/join-path";

class JobSummary extends React.Component {
  state = { isArchiveModalOpen: false };

  openArchiveModal = () => {
    this.setState({ isArchiveModalOpen: true });
  };

  closeArchiveModal = () => {
    this.setState({ isArchiveModalOpen: false });
  };

  handleArchive = () => {
    const { job, onArchive } = this.props;
    const isArchived = job.archived;

    onArchive().then(() => {
      if (isArchived) this.closeArchiveModal();
    });
  };

  renderArchiveModal() {
    const { job } = this.props;

    return (
      <Modal
        isOpen={this.state.isArchiveModalOpen}
        title={`${job.archived ? "Unarchiving" : "Archiving"} ${
          job.contractNumber
        }`}
        close={this.closeArchiveModal}
      >
        <Box p={2}>
          <P>
            Are you sure you want to {job.archived ? "unarchive" : "archive"}{" "}
            {job.contractNumber}?
          </P>
          <Flex justify="flex-end" mt={2}>
            <Button type="button" onClick={this.closeArchiveModal}>
              Cancel
            </Button>
            <Button
              type="submit"
              style={{ marginLeft: 4 }}
              variant="primary"
              onClick={this.handleArchive}
            >
              {job.archived ? "Unarchive" : "Archive"} Job
            </Button>
          </Flex>
        </Box>
      </Modal>
    );
  }

  render() {
    const { job, match } = this.props;
    const isAdmin = !!match.path.match(/^\/admin/);

    return (
      <Flex pt={3} wrap>
        <Box order={[2, 2, 1]} width={[1, 1, 2 / 3]} pr={[0, 0, 2]}>
          <H2>Recent Activity</H2>
          <JobActivities match={match} />
        </Box>
        <Box
          order={[1, 1, 2]}
          width={[1, 1, 1 / 3]}
          pl={[0, 0, 2]}
          style={{ position: "relative" }}
        >
          <H2>Services</H2>
          <LinkButton
            to={{
              pathname: joinPath(match.url, "/services/new"),
              state: { goBack: true }
            }}
            style={{ position: "absolute", right: 0, top: -6 }}
          >
            Request a service
          </LinkButton>
          <ServicesSidebar match={match} />
          {isAdmin && (
            <Box mt={4}>
              <Button
                onClick={this.openArchiveModal}
                variant={job.archived ? "success" : "danger"}
              >
                {job.archived ? "Unarchive" : "Archive"} Job
              </Button>
            </Box>
          )}
        </Box>
        {this.renderArchiveModal()}
      </Flex>
    );
  }
}

export default JobSummary;



// WEBPACK FOOTER //
// ./src/components/JobSummary.js